import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getIsLoggedIn } from '../../selectors';
import Dashboard from '../../../Dashboard';
import PrivateRoute from '../PrivateRoute';
import LoginForm from '../LoginForm';

const PagesRouter = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={LoginForm} />
        <PrivateRoute path="/evv" isLoggedIn={isLoggedIn} component={Dashboard} />
        <Redirect to={isLoggedIn ? '/evv/home' : '/login'} />
      </Switch>
    </BrowserRouter>
  );
};

export default PagesRouter;
